import React from "react";
import { Aside, IconButton, ListActionButtonProps, Stack, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { EncodeSpecificationListingItem } from "../EncodeSpecificationListingItem";
import { CloneEncodeSpecificationForm } from "../forms/clone/CloneEncodeSpecificationForm";

export type CloneEncodeSpecificationButtonProps = ListActionButtonProps<EncodeSpecificationListingItem>;

export const CloneEncodeSpecificationButton: React.FC<CloneEncodeSpecificationButtonProps> = ({
    itemId
}: CloneEncodeSpecificationButtonProps) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <>
                <IconButton tooltipContent="Copy" iconProps={{ iconName: "Tab" }} onClick={onOpen} />
                <Aside type={"form"} isOpen={isOpen} headerText="Clone Encode Specification" onDismiss={onClose}>
                    <Stack>
                        <CloneEncodeSpecificationForm onCancel={onClose} onSubmit={onClose} itemId={itemId} />
                    </Stack>
                </Aside>
            </>
        </AuthorizationWrapper>
    );
};
